import axios from './api'

export const getPosts = () => {
  return axios.get('/site/content/posts')
    .then(res => res.data.data)
}

export const getPostBySlug = (slug) => {
  return axios.get(`/site/posts/${slug}?v=${Math.random()}`)
    .then(res => res.data.data)
}

// /site/posts/morbi-feugiat-consequat-velit-ac-tincidunt-quam-gravida-ut



// http://206.189.204.88/api/site/content/posts